module.exports = __webpack_public_path__ + "img/swimming-pool.0f0b5e2f.svg";